/** Single retry after a short delay for lazy-loaded SDK chunks. */
export async function importWithOneRetry<T>(
  loader: () => Promise<T>,
  delayMs = 400,
): Promise<T | null> {
  try {
    return await loader();
  } catch {
    await new Promise((resolve) => {
      setTimeout(resolve, delayMs);
    });
    try {
      return await loader();
    } catch {
      return null;
    }
  }
}
